import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import "./App.scss";
import { Router } from "./routes/route";
import Loading from "./components/Loading";

function App() {
  return (
    <div className="lcm-app">
      <Suspense fallback={<Loading open={true} />}>
        <RouterProvider router={Router} />
      </Suspense>
    </div>
  );
}

export default App;
